const Log = console;
Log.warning = console.warn;
export default Log;